const NEW_APPOINTMENT_SOUND = '/sounds/new-appointment.mp3';
const MESSAGE_POP_ALERT_SOUND = '/sounds/message-pop-alert.mp3';

const SOUND_BY_TYPE = {
  NewAppointment: NEW_APPOINTMENT_SOUND,
  AppointmentConfirmationRequested: NEW_APPOINTMENT_SOUND,
  CancelledAppointment: MESSAGE_POP_ALERT_SOUND,
  Other: MESSAGE_POP_ALERT_SOUND,
  SupportChat: MESSAGE_POP_ALERT_SOUND,
  3: MESSAGE_POP_ALERT_SOUND,
  0: NEW_APPOINTMENT_SOUND,
  1: MESSAGE_POP_ALERT_SOUND,
  2: MESSAGE_POP_ALERT_SOUND,
  6: NEW_APPOINTMENT_SOUND,
};

const SOUND_ENABLED_KEY = 'staffNotificationSoundsEnabled';

let audioUnlocked = false;

export const areNotificationSoundsEnabled = () =>
  localStorage.getItem(SOUND_ENABLED_KEY) === 'true';

export const setNotificationSoundsEnabled = (enabled) => {
  localStorage.setItem(SOUND_ENABLED_KEY, enabled ? 'true' : 'false');
  if (enabled) {
    audioUnlocked = true;
  }
};

export const unlockNotificationSounds = async () => {
  try {
    const audio = new Audio(MESSAGE_POP_ALERT_SOUND);
    audio.volume = 0.01;
    await audio.play();
    audio.pause();
    audioUnlocked = true;
    setNotificationSoundsEnabled(true);
    return true;
  } catch {
    return false;
  }
};

export const playNotificationSound = async (type) => {
  if (!areNotificationSoundsEnabled() && !audioUnlocked) {
    return false;
  }

  const src = SOUND_BY_TYPE[type] || MESSAGE_POP_ALERT_SOUND;
  try {
    const audio = new Audio(src);
    audio.volume = 0.55;
    await audio.play();
    return true;
  } catch {
    return false;
  }
};
